Date.prototype.format = function (format) {
    var o = {
        'M+': this.getMonth() + 1, //month
        'd+': this.getDate(), //day
        'h+': this.getHours(), //hour
        'm+': this.getMinutes(), //minute
        's+': this.getSeconds(), //second
        'q+': Math.floor((this.getMonth() + 3) / 3), //quarter
        S: this.getMilliseconds() //millisecond
    };
    if (/(y+)/.test(format)) format = format.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp('(' + k + ')').test(format))
            format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    return format;
};
// 返回时间
export function getTime(time, format) {
    return new Date(time).format(format);
}
export function formatOrdertime(orderTime) {
    return orderTime ? orderTime.substring(0, 16).replace('T', ' ') : '';
}
export function user_type_list(state) {
    const statusMap = {
        super: '超级账户',
        admin: '普通管理员',
        user: '员工',
    };
    return statusMap[state] ? statusMap[state] : '';
}
export function client_user_status_list(state) {
    const statusMap = {
        wait_audit: '待审核',
        passed: '审核成功',
        failed: '审核失败',
        ban: '黑名单',
    };
    return statusMap[state] ? statusMap[state] : '';
}

export function data_detail_status_list(state) {
    const statusMap = {
        wait_audit: '待审核',
        receiving: '领取中',
        success: '领取成功',
        failed: '异常',
        not_enough: '余额不足/领取失败'
    };
    return statusMap[state] ? statusMap[state] : '';
}
export function payment_use_merchant_withdraw_list(state) {
    const statusMap = {
        yes: '使用商户提现',
        no: '使用企业提现',
        
    };
    return statusMap[state] ? statusMap[state] : '';
}

// 中国标准时间转为 年月日
export function newDate(time) {
    var date = new Date(time);
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? '0' + m : m;
    var d = date.getDate();
    d = d < 10 ? '0' + d : d;
    return y + '-' + m + '-' + d;
}

export function parseParmStr(parmStr) {
	if (parmStr.indexOf("?") != -1) {
		var index = parmStr.indexOf('?');
		var parms = {};
		parmStr = parmStr.substr(index + 1);
		let strs = parmStr.split('&'); //["userName=mona", "pwd=3"]

		for (var i = 0; i < strs.length; i++) {
			parms[strs[i].split('=')[0]] = strs[i].split('=')[1];
		}
	}
	return parms;
}